<div class="absolute inset-0 flex min-w-0 flex-auto flex-col overflow-hidden">
  <mat-drawer-container class="bg-card h-full flex-auto" (backdropClick)="backdropClicked()">
    <mat-drawer
      #detailsDrawer
      class="w-screen min-w-screen bg-slate-100"
      [disableClose]="true"
      [mode]="'over'"
      [ngClass]="{ 'md:w-280 md:min-w-280': drawerType() === 'view', 'md:w-120 md:min-w-120': drawerType() === 'search' }"
      [opened]="false"
      [position]="'end'">
      @if (drawerType() === 'view') {
        <router-outlet></router-outlet>
      }
    </mat-drawer>

    <mat-drawer-content class="flex flex-col overflow-hidden">
      <div class="relative flex flex-0 flex-col justify-between p-6">
        @if (isLoading()) {
          <div class="absolute inset-x-0 bottom-0">
            <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
          </div>
        }

        <div class="text-2xl font-extrabold tracking-tight">{{ 'ship_interface.timesheet' | transloco }}</div>

        <div class="mt-4 flex w-full shrink-0 items-center justify-between">
          <shared-advance-filter-container
            [config]="advanceFilterConfig"
            [queryParams]="queryParams()"
            [queryListAdvanceFilter]="queryAdvanceFilter"
            (queryParamsChangedEvent)="queryParams.set($event)"
            (navigateWithParamsEvent)="navigateWithParams($event)" />

          <div class="flex shrink-0 items-center space-x-1 md:space-x-4">
            <button mat-flat-button class="dark-excel-button hidden md:flex" [color]="'accent'" (click)="exportJobExcel()" [disabled]="downloadingExcel()">
              @if (downloadingExcel()) {
                <mat-spinner class="h-4 w-4 dark:text-slate-50"></mat-spinner>
              } @else {
                <div class="flex items-center">
                  <mat-icon class="icon-size-5" [svgIcon]="'sealicons_outline:excel'"></mat-icon>
                  <span class="ml-2 mr-1">{{ 'button.excel' | transloco }}</span>
                </div>
              }
            </button>

            <button
              *permission="['time_sheet_sof', ['create']]"
              mat-flat-button
              class="hidden bg-primary md:flex"
              [color]="'primary'"
              (click)="createTimesheet()">
              <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:plus'"></mat-icon>

              <span class="ml-2 mr-1">{{ 'button.add' | transloco }}</span>
            </button>

            <div class="md:hidden">
              <button mat-icon-button [matMenuTriggerFor]="actionMenu">
                <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:ellipsis-vertical'"></mat-icon>
              </button>

              <mat-menu #actionMenu="matMenu">
                <button mat-menu-item (click)="exportJobExcel()" [disabled]="downloadingExcel()">
                  <mat-icon class="icon-size-5" [svgIcon]="'sealicons_outline:excel'"></mat-icon>

                  {{ 'button.excel' | transloco }}
                </button>

                <button *permission="['time_sheet_sof', ['create']]" mat-menu-item (click)="createTimesheet()">
                  <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:plus'"></mat-icon>

                  {{ 'button.add' | transloco }}
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-auto overflow-hidden px-6">
        <div class="flex flex-auto flex-col overflow-y-auto sm:mb-[73px]">
          <lync-table class="h-full" [config]="tableConfig" [rows]="timesheets()">
            <ng-template lyncTableTemplate="actions" let-timesheet>
              <button
                mat-icon-button
                [matMenuTriggerData]="{ timesheet: timesheet }"
                [matMenuTriggerFor]="timesheetMenu"
                (click)="$event.stopPropagation(); $event.preventDefault()">
                <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:ellipsis-vertical'"></mat-icon>
              </button>
            </ng-template>
          </lync-table>

          <mat-menu #timesheetMenu="matMenu" class="grid-menu">
            <ng-template matMenuContent let-timesheet="timesheet">
              <button *permission="['time_sheet_sof', ['delete']]" mat-menu-item (click)="deleteTimesheet(timesheet)">
                <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                {{ 'ship_interface.delete' | transloco }}
              </button>
            </ng-template>
          </mat-menu>

          <mat-paginator
            class="bg-card z-10 flex items-center justify-end border-b sm:absolute sm:inset-x-6 sm:bottom-0 sm:border-b-0 sm:border-t"
            [length]="pagination()?.total"
            [ngClass]="{ 'pointer-events-none': isLoading() }"
            [pageIndex]="pagination()?.current_page - 1"
            [pageSizeOptions]="[10, 25, 50, 100]"
            [pageSize]="pagination()?.per_page"
            [showFirstLastButtons]="true"></mat-paginator>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
